// Nombre del regalo en el resumen de «Arma la venta» (slot `giftName`): si el catálogo
// no lo resolvió (queda el SKU), lo toma de Promociones, de lo ya visto o del catálogo del wizard.
import { useQueryClient } from '@tanstack/react-query';
import { WIZARD_KEYS } from '@/domains/sales/wizard/api/useWizard';
import type { CatalogResponse } from '@/domains/sales/wizard/types';
import { itemDisplayName } from '@/shared/lib/format/itemDisplayName';
import { useSalePromotionEvaluation } from '../api/useWizardPromotions';
import { giftNameOf } from '../lib/giftPanel';
import { rememberedGiftName } from '../lib/promotionNames';

export interface SummaryGiftNameProps {
    sessionId: string;
    sku: string;
    /** Nombre que resolvió el catálogo; es el SKU cuando no lo conoce. */
    catalogName: string;
}

export function SummaryGiftName({ sessionId, sku, catalogName }: SummaryGiftNameProps) {
    const { data } = useSalePromotionEvaluation(sessionId);
    const queryClient = useQueryClient();
    if (catalogName !== sku) return <>{catalogName}</>;
    // Solo el catálogo ya cargado por el paso: el resumen no dispara otra lectura.
    const catalog = queryClient.getQueryData<CatalogResponse>(WIZARD_KEYS.catalog(sessionId));
    const item = catalog?.items.find((i) => i.sku === sku);
    const fromCatalog = item ? itemDisplayName(item) : undefined;
    return (
        <>
            {giftNameOf(data, sku) ??
                rememberedGiftName(sessionId, sku) ??
                (fromCatalog !== sku ? fromCatalog : undefined) ??
                catalogName}
        </>
    );
}
